import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { GestockService } from '../services/gestock.service';
import { formatDate } from '@angular/common';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-credit-fournisseur',
  templateUrl: './credit-fournisseur.component.html',
  styleUrls: ['./credit-fournisseur.component.css']
})
export class CreditFournisseurComponent implements OnInit {

  samacaabiyoonwii: any;
  profil: string = '';
  isReadOnly: boolean = false;
  boutiques: any[] = [];
  selectedBoutique: any = null;
  fournisseurs: any[] = [];
  transactions: any[] = [];
  fournisseurActif: any = null;
  datedeb: Date;
  datefin: Date;
  
  nouveauFournisseur = { nom: '', telephone: '', adresse: '' };
  nouvelleTransaction = { id_fournisseur: '', type_transaction: 'dette', montant: 0, description: '' };

  @ViewChild('editFournisseurDialog') editFournisseurDialog: TemplateRef<any>;
  editFournisseurDialogRef: MatDialogRef<any>;
  fournisseurAEditer: any = { id: null, nom: '', telephone: '', adresse: '' };

  constructor(private gestockService: GestockService, public dialog: MatDialog) {
    this.samacaabiyoonwii = sessionStorage.getItem("samacaabiyoonwii");
    this.profil = sessionStorage.getItem("profil") || '';
    this.isReadOnly = this.profil === 'ADMINISTRATEUR' || this.profil === 'Contrôleur de Gestion';
    this.datedeb = new Date(new Date().setDate(new Date().getDate() - 30));
    this.datefin = new Date();
  }

  ngOnInit(): void {
    if (this.isReadOnly) {
      this.gestockService.getAllPoints(this.samacaabiyoonwii).then(res => {
        if(res.statutreq == 1) {
          this.boutiques = res.data;
          if (this.boutiques && this.boutiques.length > 0) {
            this.selectedBoutique = this.boutiques[0].idPoint;
            this.loadData();
          }
        }
      });
    } else {
      this.loadData();
    }
  }

  loadData() {
    const payload = this.selectedBoutique ? { idboutique: this.selectedBoutique } : {};
    this.gestockService.fournisseurApi(this.samacaabiyoonwii, 'get_fournisseurs', payload).then(res => {
      if(res.statutreq == 1) {
        this.fournisseurs = res.data;
        this.fournisseurActif = null;
        this.transactions = [];
        this.currentPageFournisseurs = 1;
      }
    });
  }

  onBoutiqueChange() {
    this.loadData();
  }

  voirDetails(fournisseur) {
    this.fournisseurActif = fournisseur;
    this.nouvelleTransaction.id_fournisseur = fournisseur.id;
    this.chargerTransactions();
  }

  chargerTransactions() {
    if(!this.fournisseurActif) return;
    const start = formatDate(this.datedeb, 'yyyy-MM-dd', 'en-US');
    const end = formatDate(this.datefin, 'yyyy-MM-dd', 'en-US');
    const payload = {
      id_fournisseur: this.fournisseurActif.id,
      date_debut: start,
      date_fin: end
    };
    this.gestockService.fournisseurApi(this.samacaabiyoonwii, 'get_transactions', payload).then(res => {
      if(res.statutreq == 1) {
        this.transactions = res.data;
        this.currentPage = 1;
      }
    });
  }

  // Fournisseurs Pagination
  currentPageFournisseurs: number = 1;
  pageSizeFournisseurs: number = 10;

  get paginatedFournisseurs() {
    const start = (this.currentPageFournisseurs - 1) * this.pageSizeFournisseurs;
    return this.fournisseurs.slice(start, start + this.pageSizeFournisseurs);
  }

  totalPagesFournisseurs(): number {
    return Math.ceil(this.fournisseurs.length / this.pageSizeFournisseurs) || 1;
  }

  getPagesFournisseurs(): number[] {
    const total = this.totalPagesFournisseurs();
    const current = this.currentPageFournisseurs;
    const pages: number[] = [];
    let start = Math.max(1, current - 2);
    let end = Math.min(total, start + 4);
    if (end - start < 4) {
      start = Math.max(1, end - 4);
    }
    for (let i = start; i <= end; i++) {
      pages.push(i);
    }
    return pages;
  }

  getRangeLabelFournisseurs(): string {
    if (this.fournisseurs.length === 0) {
      return '0 sur 0';
    }
    const start = (this.currentPageFournisseurs - 1) * this.pageSizeFournisseurs + 1;
    const end = Math.min(start + this.pageSizeFournisseurs - 1, this.fournisseurs.length);
    return `${start} - ${end} sur ${this.fournisseurs.length}`;
  }

  // Transactions Pagination
  currentPage: number = 1;
  pageSize: number = 10;

  get paginatedTransactions() {
    const start = (this.currentPage - 1) * this.pageSize;
    return this.transactions.slice(start, start + this.pageSize);
  }

  totalPages(): number {
    return Math.ceil(this.transactions.length / this.pageSize) || 1;
  }

  getPages(): number[] {
    const total = this.totalPages();
    const current = this.currentPage;
    const pages: number[] = [];
    let start = Math.max(1, current - 2);
    let end = Math.min(total, start + 4);
    if (end - start < 4) {
      start = Math.max(1, end - 4);
    }
    for (let i = start; i <= end; i++) {
      pages.push(i);
    }
    return pages;
  }

  getRangeLabel(): string {
    if (this.transactions.length === 0) {
      return '0 sur 0';
    }
    const start = (this.currentPage - 1) * this.pageSize + 1;
    const end = Math.min(start + this.pageSize - 1, this.transactions.length);
    return `${start} - ${end} sur ${this.transactions.length}`;
  }

  ajouterFournisseur() {
    if(this.isReadOnly) return;
    if(!this.nouveauFournisseur.nom) return;
    this.gestockService.fournisseurApi(this.samacaabiyoonwii, 'add_fournisseur', this.nouveauFournisseur).then(res => {
      if(res.statutreq == 1) {
        this.nouveauFournisseur = { nom: '', telephone: '', adresse: '' };
        this.loadData();
      }
    });
  }

  ouvrirEditionFournisseur(fournisseur: any, event?: Event) {
    if (event) event.stopPropagation();
    if (this.isReadOnly) return;
    this.fournisseurAEditer = { ...fournisseur };
    this.editFournisseurDialogRef = this.dialog.open(this.editFournisseurDialog, { width: '450px' });
  }

  sauvegarderFournisseur() {
    if (this.isReadOnly) return;
    if (!this.fournisseurAEditer.nom) return;

    this.gestockService.updateFournisseur(this.samacaabiyoonwii, this.fournisseurAEditer).then(res => {
      if (res.statutreq == 1) {
        if (this.editFournisseurDialogRef) this.editFournisseurDialogRef.close();
        if (this.fournisseurActif && this.fournisseurActif.id === this.fournisseurAEditer.id) {
          this.fournisseurActif.nom = this.fournisseurAEditer.nom;
          this.fournisseurActif.telephone = this.fournisseurAEditer.telephone;
          this.fournisseurActif.adresse = this.fournisseurAEditer.adresse;
        }
        this.loadData();
      } else {
        alert("Erreur: " + res.message);
      }
    });
  }

  ajouterTransaction() {
    if(this.isReadOnly) return;
    if(!this.nouvelleTransaction.id_fournisseur || this.nouvelleTransaction.montant <= 0) return;
    this.gestockService.fournisseurApi(this.samacaabiyoonwii, 'add_transaction', this.nouvelleTransaction).then(res => {
      if(res.statutreq == 1) {
        alert("Transaction enregistrée !");
        this.nouvelleTransaction.montant = 0;
        this.nouvelleTransaction.description = '';
        this.loadData();
        this.chargerTransactions(); // Refresh transactions
        // Update local status
        if(this.nouvelleTransaction.type_transaction == 'dette') {
           this.fournisseurActif.solde_dette += this.nouvelleTransaction.montant;
        } else {
           this.fournisseurActif.solde_dette -= this.nouvelleTransaction.montant;
        }
      }
    });
  }
}
